import { Alert, Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useHatm } from '../../context/HatmContext';

export default function AlertSystem() {
  const { 
    alert, 
    setAlert, 
    alertMessage, 
    successAlert, 
    setSuccessAlert 
  } = useHatm();

  return (
    <>
      <Collapse in={successAlert}>
        <Alert
          severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setSuccessAlert(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          Bağlantı başarıyla kopyalandı!
        </Alert>
      </Collapse>

      <Collapse in={alert}>
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setAlert(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alertMessage}
        </Alert>
      </Collapse>
    </>
  );
} 